import { render } from "./BackgroundShades.vue?vue&type=template&id=5a984d82&scoped=true"
import script from "./BackgroundShades.vue?vue&type=script&lang=js"
export * from "./BackgroundShades.vue?vue&type=script&lang=js"

import "./BackgroundShades.vue?vue&type=style&index=0&id=5a984d82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a984d82"]])

export default __exports__